import React from "react";
import Loadable from "react-loadable";

import Home from "../containers/Home";

function Loading() {
  return <div>Loading...</div>;
}

const Projects = Loadable({
  loader: () => import("../containers/views/Projects"),
  loading: Loading
});

const Dashboard = Loadable({
  loader: () => import("../containers/views/Dashboard"),
  loading: Loading
});

const Job = Loadable({
  loader: () => import("../containers/views/Job"),
  loading: Loading
});

const JobCreate = Loadable({
  loader: () => import("../containers/views/JobCreate"),
  loading: Loading
});

const JobDefinitions = Loadable({
  loader: () => import("../containers/views/JobDefinitions"),
  loading: Loading
});

const DataManager = Loadable({
  loader: () => import("../containers/views/DataManager"),
  loading: Loading
});

const Notifications = Loadable({
  loader: () => import("../containers/views/Notifications"),
  loading: Loading
});

const Training = Loadable({
  loader: () => import("../containers/views/Training"),
  loading: Loading
});

const Newness = Loadable({
  loader: () => import("../containers/views/Newness"),
  loading: Loading
});

const ClassNewness = Loadable({
  loader: () => import("../containers/views/ClassNewness"),
  loading: Loading
});

const Robustness = Loadable({
  loader: () => import("../containers/views/Robustness"),
  loading: Loading
});

const ClassRobustness = Loadable({
  loader: () => import("../containers/views/ClassRobustness"),
  loading: Loading
});

const TensorBoard = Loadable({
  loader: () => import("../containers/views/TensorBoard"),
  loading: Loading
});

const Apps = Loadable({
  loader: () => import("../containers/views/Apps"),
  loading: Loading
});

const UserManagement = Loadable({
  loader: () => import("../containers/views/UserManagement"),
  loading: Loading
});

const Roles = Loadable({
  loader: () => import("../containers/views/Roles"),
  loading: Loading
});

const Storage = Loadable({
  loader: () => import("../containers/views/Storage"),
  loading: Loading
});

const ComputeEnv = Loadable({
  loader: () => import("../containers/views/ComputeEnv"),
  loading: Loading
});

const Security = Loadable({
  loader: () => import("../containers/views/Security"),
  loading: Loading
});

const CloudStorage = Loadable({
  loader: () => import("../containers/views/CloudStorage"),
  loading: Loading
});

const LocalStorage = Loadable({
  loader: () => import("../containers/views/LocalStorage"),
  loading: Loading
});

const JobDfnCreateUpdate = Loadable({
  loader: () => import('../containers/views/JobDfnCreateUpdate'),
  loading: Loading,
});

const FileData = Loadable({
  loader: () => import("../containers/views/FileData"),
  loading: Loading
});

const FileDetail = Loadable({
  loader: () => import("../containers/views/FileDetail"),
  loading: Loading
});

const ModelGenerator = Loadable({
  loader: () => import("../containers/views/ModelGenerator"),
  loading: Loading
});


const DigitalTwin = Loadable({
  loader: () => import("../containers/views/DigitalTwin"),
  loading: Loading
});

const TwinManager = Loadable({
  loader: () => import("../containers/views/TwinManager"),
  loading: Loading
});


const TwinComponent = Loadable({
  loader: () => import("../containers/views/TwinComponent"),
  loading: Loading
});


const ReleaseManager = Loadable({
  loader: () => import("../containers/views/ReleaseManager"),
  loading: Loading
});

const ActiveModelManager = Loadable({
  loader: () => import("../containers/views/ActiveModelManager"),
  loading: Loading
});

const ModelRelease = Loadable({
  loader: () => import("../containers/views/ModelRelease"),
  loading: Loading
});

const ActiveModel = Loadable({
  loader: () => import("../containers/views/ActiveModel"),
  loading: Loading
});

const PriorReleases = Loadable({
  loader: () => import("../containers/views/PriorReleases"),
  loading: Loading
});

const DowngradeModel = Loadable({
  loader: () => import("../containers/views/DowngradeModel"),
  loading: Loading
});

const routes = [
  { path: '/', name: '', component: Home, exact: true },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard, exact: true },
  { path: '/projects', name: 'Projects', component: Projects, exact: true },
  { path: '/jobsmget/job', name: 'Jobs', component: Job },
  { path: '/jobsmget/jobcreate', name: 'Create or Clone Job', component: JobCreate },
  { path: '/jobsmget/jobdef', name: 'Job Definitions', component: JobDefinitions },
  { path: '/jobsmget/cujobdfn', name: 'Create/Update Job Definition', component: JobDfnCreateUpdate },
  { path: '/datamanager', name: 'Data Manager', component: DataManager },
  { path: '/datamanager/filedetails', name: 'File Details', component: FileDetail },
  { path: '/datamanager/filedata', name: 'File Data', component: FileData },
  { path: '/notifications', name: 'Notifications', component: Notifications },
  { path: '/tensorboard', name: 'TensorBoard', component: TensorBoard },
  { path: '/apps', name: 'AI4AI: Solution Centric AI Generators', component: Apps },
  { path: '/digitaltwin', name: 'AI and IOT Driven Asset AI Managers', component: DigitalTwin },
  { path: '/twinmanager', name: 'Asset AI Manager', component: TwinManager },
  { path: '/twincmp', name: 'Asset Component', component: TwinComponent },
  { path: '/settings/usermanagement', name: 'User Management', component: UserManagement },
  { path: '/settings/roles', name: 'Roles & Premission', component: Roles },
  { path: '/settings/storage', name: 'Storage Settings', component: Storage },
  { path: '/settings/environments', name: 'Compute Environments', component: ComputeEnv },
  { path: '/settings/security', name: 'Security Settings', component: Security },
  { path: '/settings/cloudstorage', name: 'Cloud Storage Settings', component: CloudStorage },
  { path: '/settings/localstorage', name: 'Local Storage Settings', component: LocalStorage },
  { path: '/analytics/training', name: 'Training', component: Training },
  { path: '/analytics/newness', name: 'Newness', component: Newness },
  { path: '/analytics/classnewness', name: 'ClassNewness', component: ClassNewness },
  { path: '/analytics/robustness', name: 'Robustness', component: Robustness },
  { path: '/analytics/classrobustness', name: 'ClassRobustness', component: ClassRobustness },
  { path: '/pmaintenance', name: 'Predictive Maintenance Model Generator', component: ModelGenerator },
  { path: '/pmonitoring', name: 'Process Monitoring Model Generator', component: ModelGenerator },
  { path: '/multimodal', name: 'Multi-modal Model Generator for Classification or Regression', component: ModelGenerator },
  { path: '/ts_anomaly', name: 'Time Series Anomaly Detection', component: ModelGenerator },
  { path: '/anomaly', name: 'Non Time Series Anomaly Detection', component: ModelGenerator },
  { path: '/inspection', name: 'Visual Inspection of Industrial Structures', component: ModelGenerator },
  { path: '/object_detection', name: 'Visual Inspection of Industrial Structures', component: ModelGenerator },
  { path: '/releasemgr', name: 'AI Model Release Management', component: ReleaseManager },
  { path: '/activemodelmgr', name: 'AI Model Release Management', component: ActiveModelManager },
  { path: '/priorreleases', name: 'AI Model Release Management', component: PriorReleases },
  { path: '/modelrelease', name: 'Release New or Update Current AI Model', component: ModelRelease },
  { path: '/activemodel', name: 'Change Active Model', component: ActiveModel },
  { path: '/downgrademodel', name: 'Downgrade Current Model Release', component: DowngradeModel },
];

export default routes;



// WEBPACK FOOTER //
// ./src/config/routes.js